export default __webpack_public_path__ + "static/media/FramedImage.c570c38b.png";